import { Component } from '@angular/core';

@Component({
  selector: 'app-snow-effect',
  templateUrl: './snow-effect.component.html',
  styleUrls: ['./snow-effect.component.scss'],
  standalone: false,
})
export class SnowEffectComponent {
  private snowflakeAmount: number = 60; //NOTE: This number is supposed to correspond with the $SNOWFLAKES_AMOUNT value in the stylesheet
  public snowFlakeElements: HTMLLIElement[] = [];

  constructor() {
    for (let i = 0; i < this.snowflakeAmount; i++) {
      this.snowFlakeElements.push(document.createElement('li'));
    }
  }
}
